export const twoStepAuthenticationStyles = {
	wrapper: {
		marginTop: '24px',
		display: 'flex',
		flexDirection: 'column',
		gap: '24px',
	},

	content: {
		textAlign: 'center',
	},

	title: {
		fontWeight: '700',
		color: 'var(--primary-500)',
		marginBottom: '4px',
	},

	form: {
		display: 'flex',
		justifyContent: 'center',
		marginTop: '12px',

		'& input': {
			width: '42px',
			height: '44px',
			border: '1px solid var(--neutral-200)',
			textAlign: 'center',
			fontSize: '16px',

			'&:first-child ': {
				borderRadius: '8px 0 0 8px',
			},

			'&:last-child': {
				borderRadius: '0 8px 8px 0',
			},
		},
	},

	qr: {
		marginTop: '12px',
		display: 'flex',
		alignItems: 'center',
		gap: '24px',

		'& h6': {
			textAlign: 'start',
		},
	},

	description: {
		'& a': {
			color: 'var(--primary-500)',
			display: 'inline',
			margin: '0 4px',
		},
	},

	mainTitle: {
		fontSize: '24px',
		fontWeight: '700',
		textAlign: 'center',
		whiteSpace: 'nowrap',
		marginTop: '32px',
		marginBottom: '8px',
	},
	mainDescription: {
		paddingTop: '8px',
		textAlign: 'center',
		fontSize: '16px',
		lineHeight: '24px',
	},
	buttonWrapper: {
		display: 'flex',
		justifyContent: 'space-evenly',
		gap: '24px',
		marginTop: '32px',
	},

	icon: {
		display: 'flex',
		margin: '0 auto',
		height: '60px',
		width: '60px',
	},
	iconChecked: {
		display: 'flex',
		margin: '0 auto',
		height: '60px',
		width: '60px',
		'& svg': {
			fill: 'var(--primary-500)',
			height: '60px',
			width: '60px',
		},
	},
};
